export const premiumFeatures = {
    reactions: 'reactions',
    moderation_group: 'moderation_group',
    message_search_v3: 'message_search_v3',
    data_export: 'data_export',
    migration: 'migration',
    delivery_receipt: 'delivery_receipt',
    auto_thumbnail: 'auto_thumbnail',
    image_moderation: 'image_moderation',
    super_group_channel: 'super_group_channel',
    announcement: 'announcement',
    moderation_open: 'moderation_open',
    desk: 'desk',
    bot_interface: 'bot_interface',
    auto_trans: 'auto_trans',
};
